import createVueComponent from '../createVueComponent';

const Clock8 = createVueComponent('Clock8Icon', [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['polyline', { points: '12 6 12 12 8 14' }],
]);

export default Clock8;
